import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import '../assets/css/features.css';
import { Spinner, Button } from 'reactstrap';
import { ListGroup } from "react-bootstrap";
import moment from 'moment';
import '../assets/css/login.css';
import feature_img_1 from '../assets/images/feature_img_1.png';
import { GetFeatures } from '../utils/apis';
import { hasValue, ProcessAPIError } from '../utils/common_functions';
import { Layout } from './Layout';
import { FaCheckCircle } from "react-icons/fa";
import { CreateCustomerSession } from '../utils/apis';

const FeaturePaymentSuccess = () => {
    const [searchParams] = useSearchParams();

    const [selected_feature, setSelected_feature] = useState(null);
    const [all_features, setFeatures] = useState(null);
    const [new_purchase_devices, Setnew_purchase_devices] = useState(null);

    const GetData = async () => {
        let obj = JSON.parse(localStorage.getItem('auth'));
        let resp = await GetFeatures(obj.device_id);
        let data = resp.data
        setFeatures(data)

        const allFeatures = data.features.flatMap(a => a.features);
        let feature_id = searchParams.get('feature_id');
        if (hasValue(feature_id)) {
            setSelected_feature(allFeatures.find(a => a.id === feature_id));

            let device_id = searchParams.get('device_id');
            if (hasValue(device_id) && hasValue(data?.device_features?.length)) {
                let device_features = data.device_features.find(a => a.id === device_id)
                if (device_features !== null && hasValue(device_features?.feature_purchase?.length)) {
                    let purchase_made = device_features.feature_purchase.find(a => a.featureId === feature_id);
                    Setnew_purchase_devices(purchase_made)
                }
            }
        }
    }

    useEffect(() => {
        setTimeout(() => { // Needed here to getting the data for stripe web hook
            GetData();
        }, 3000)

    }, []);

    const FeatureImage = ({ imageURL }) => {
        return (
            <>
                {imageURL === "feature_img_1" && <img src={feature_img_1} alt="Icon" className="me-3" />}
            </>)
    }

    const SelFeatureDesc = ({ feature }) => {
        return (
            <>
                <ListGroup className="m-3 p-4" style={{ border: "solid 1px #ccc" }}>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <div className={"d-flex align-items-center"}>
                            {hasValue(feature?.imageURL) &&
                                <FeatureImage imageURL={feature.imageURL} />
                            }
                            <div>
                                <h5>
                                    {feature.featureName}
                                </h5>
                            </div>
                        </div>
                    </div>
                    {/*{new_purchase_devices !== null && hasValue(new_purchase_devices?.validTo) &&*/}
                    {/*    <>*/}
                    <div className="text-muted feature_desc" style={{ textAlign: "right" }}>
                        ${feature.price}/month - renews on {moment().add(1, 'months').format('DD/MM/YYYY')}
                    </div>
                    {/*    </>*/}
                    {/*}*/}
                </ListGroup>
            </>
        )
    }

    const SelectedFeatureView = () => {
        return (
            <>
                <SelFeatureDesc feature={selected_feature} />
            </>
        )
    }

    const GenerateCustomerSession = async () => {
        try {
            let obj = JSON.parse(localStorage.getItem('auth'));

            let resp = await CreateCustomerSession(obj.device_id);
            window.location.href = resp.data.url;
        }
        catch (error) {
            alert(ProcessAPIError(error));
        }
    }

    return (
        <Layout>
            {all_features !== null ?
                <>
                    <ListGroup className="w-100 mt-5 pt-5">
                        <div className="text-center">
                            <FaCheckCircle size={75} color="4285F4" />
                        </div>
                        <div className="text-center mt-4">
                            <h1 class="color_cw">Order Completed!</h1>
                        </div>
                        {selected_feature !== null &&
                            <>
                                <SelectedFeatureView />
                            </>
                        }
                        <div class="m-2 mt-4">
                            <Button style={{ width: "100%" }} color="primary" onClick={(e) => { e.preventDefault(); window.location.href = "/features" }}>Browse more add-ons</Button>
                        </div>
                        <div class="m-2 mt-3">
                            <Button style={{ width: "100%" }} color="light" onClick={(e) => { e.preventDefault(); GenerateCustomerSession(); }}>Manage My add-ons</Button>
                        </div>
                        <div class="m-2 mt-3 text-center">
                            <a href="#" onClick={(e) => { e.preventDefault(); window.location.href = "mf2sc://open/my-addons" }} style={{ textDecoration: "none" }}>Return to <i><strong>Care</strong> Window</i> app</a>
                        </div>
                    </ListGroup>
                </>
                :
                <div class="spinner-div">
                    <Spinner color="primary" /> </div>}
        </Layout>
    );
}

export default FeaturePaymentSuccess;